import * as yup from 'yup';
import { EVENT_TYPES } from 'constants/eventTypes';
import { REQUIRED_FIELD, MIN, MAX } from 'constants/validations';

export const initialValues = {
  otherEventType: '',
  selectedEventType: '',
};

const isOther = (selectedEventType) => selectedEventType === EVENT_TYPES.OTHERS;

export const schema = yup.object().shape({
  selectedEventType: yup.string(),
  otherEventType: yup.string().when('selectedEventType', {
    is: isOther,
    then: yup.string().required(REQUIRED_FIELD).min(4, MIN).max(40, MAX),
    otherwise: yup.string(),
  }),
});

export const mapPropsToValues = ({ giftTableFlowValues = {} }) => ({
  ...initialValues,
  otherEventType:
    giftTableFlowValues.category && giftTableFlowValues.category.label
      ? giftTableFlowValues.category.label
      : initialValues.otherEventType,
});
